import React, { useState } from "react"
import EmailIcon from '../../assets/images/lystfacelogos/EmailIcon.png'
import ContentPopup, { supportContent } from "../../pages/Dashboard/home/helper/ContentPopup"

const SupportButton = () => {
    const [openSupport, setOpenSupport] = useState(false)
    return (
        <div className='support-button-container'>
            <button className='support-button' onClick={() => setOpenSupport(true)}>
                <div>
                    <img src={EmailIcon} />
                </div>
                Support
            </button>
            {openSupport && <ContentPopup
                resetParent={() => setOpenSupport(false)}
                title={'Support'}
                content={supportContent}
            />}
        </div>
    )
}

export default SupportButton
